

























import Component, { mixins } from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Modal from "@/mixins/Modal";
import BaseIcon from "@/components/BaseIcon";
import CustomScroll from "@/components/CustomScroll";
import PageTitle from "@/components/PageTitle";

@Component({ name: "ModalView", components: { PageTitle, BaseIcon, CustomScroll } })
export default class ModalView extends mixins(Modal) {
  @Prop({ type: String })
  public readonly title!: string;

  @Prop({ type: Boolean, default: true })
  public readonly scrollable!: boolean;

  @Prop({ type: String })
  public readonly wrapperClass!: string;
}
